module.exports = __webpack_public_path__ + "img/down9.7fc659dc.png";